export const API_ROOT = 'api/'
export const AUTH_STORAGE_KEY = 'alfa_auth_data'
export const COLOR = '#007bff'
export const FILE_SUPPORTED_EXTENSIONS = 'xls,xlsx,doc,docx,pdf,png,jpg,jpeg'
export const IMAGE_FILE_SUPPORTED_EXTENSIONS = 'png,jpg,jpeg'
export const FILE_MAX_SIZE = 2097152 // 2 MB
export const IMAGE_FILE_MAX_SIZE = 307299 // 300 KB
export const DEFAULT_LOCALE = 'sk'
export const YEARS_MIN = 2015
export const GOOGLE_MAP_SEARCH_URL = 'https://www.google.com/maps/search/'
export const GOOGLE_MAP_DIRECTION_URL = 'https://www.google.com/maps/dir/'
export const SMARTBRAINS_URL = 'https://www.smartbrains.cz'

export const CHART_COLORS = {
  green: '#00A65A',
  red: '#DD4B39',
  redLight: '#f95d6a',
  blue: '#003f5c',
  blueLight: '#0073B7',
  purple: '#665191',
  purpleLight: '#a05195',
  orange: '#ff7c43',
  orangeLight: '#ffa600',
  turquoise: '#48D1CC'
}
